module.exports = require("./yo.js");